import { Helmet } from "react-helmet-async";

interface HelmetTagsProps {
    title?: string;
    description?: string;
    imgUrl?: string;
    url?: string;
    jsonLd?: any;
}

const HelmetTags: React.FC<HelmetTagsProps> = ({
    title = "Anystay | Short & Long Stays, Holiday Homes, Rooms & More",
    description = "Book the perfect Australian stay at the best prices with Anystay. Find amazing deals on the biggest range of accommodation in Australia.",
    imgUrl = "https://d292awxalydr86.cloudfront.net/General/Stays+in+Australia.jpg",
    url = "https://www.anystay.com/",
    jsonLd,
}) => {
    return (
        <Helmet>
            <html lang="en-AU" />
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            <meta name="robots" content="index, follow" />
            {/* <link rel="icon" href="/logo192.png" type="image/png" /> */}
            <title>{title}</title>
            <link rel="canonical" href={url} />

            {/* Primary Meta Tags */}
            <meta name="title" content={title} />
            <meta name="description" content={description} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content="website" />
            <meta property="og:url" content={url} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={imgUrl} />
            <meta property="og:image:secure_url" content={imgUrl} />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
            <meta property="og:site_name" content="Anystay" />
            <meta property="og:locale" content="en_AU" />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@anystayapp" />
            <meta name="twitter:creator" content="@anystayapp" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={imgUrl} />
            <meta name="twitter:url" content={url} />

            {/* LinkedIn */}
            <meta property="linkedin:title" content={title} />
            <meta property="linkedin:description" content={description} />
            <meta property="linkedin:image" content={imgUrl} />
            <meta property="linkedin:url" content={url} />

            {/* Pinterest */}
            <meta property="pinterest:title" content={title} />
            <meta property="pinterest:description" content={description} />
            <meta property="pinterest:image" content={imgUrl} />
            <meta property="pinterest:url" content={url} />

            {/* WhatsApp */}
            <meta property="og:image:type" content="image/jpeg" />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />

            {/* JSON-LD */}
            {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
        </Helmet>
    );
};

export default HelmetTags;
